function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: -1,
  y1: 26.9824,
  x2: 1439,
  y2: 26.9824,
  stroke: "#DCFF79"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M491.981 27.4829C481.154 31.123 472.64 39.6371 469 50.464C465.36 39.6371 456.846 31.123 446.019 27.4829C456.846 23.8429 465.36 15.3288 469 4.50193C472.64 15.3288 481.154 23.8429 491.981 27.4829Z",
  fill: "black",
  stroke: "#DCFF79",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1092.48 27.4829C1081.65 31.123 1073.14 39.6371 1069.5 50.464C1065.86 39.6371 1057.34 31.123 1046.51 27.4829C1057.34 23.8429 1065.86 15.3288 1069.5 4.50193C1073.14 15.3288 1081.65 23.8429 1092.48 27.4829Z",
  fill: "black",
  stroke: "#DCFF79",
  strokeWidth: 2
});

function SvgFooterStarLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 55,
    viewBox: "0 0 1439 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterStarLine);
export default __webpack_public_path__ + "static/media/footer-star-line.ec60b3e5.svg";
export { ForwardRef as ReactComponent };